import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ModulosDocumentumUtilService } from "./modulos-documento-util.service";
import { DocumentBinary, DocumentData, DocumentumDeleteResponse, DocumentumGetResponse, DocumentumIdentificModulo, DocumentumResult, DocumentumStoreResponse, ListAllDocumentum } from "src/app/models/documentum/documentum.model";

@Injectable({
    providedIn: "root",
})
export class DocumentumService {

    private url = `${environment.wsUrlDominioDocumentum}/document`;

    private separadorParametros = "-";

    private headerRequest = {
        service: "20",
        domain: "1360",
        business: "1",
        channel: "1",
        requestClient: "1",
        requestDate: new Date().toISOString()
    };

    private authentication = {
        username: "expgnrl02",
    };

    constructor(private http: HttpClient, private metadatosDocumentumService: ModulosDocumentumUtilService) {

    }

    public store(documentData: DocumentData, documentBinary: DocumentBinary): Observable<DocumentumStoreResponse> {
        const documentum: DocumentumResult = {
            headerRequest: this.headerRequest,
            businessRequest: {
                storeDocumentData: {
                    authentication: this.authentication,
                    documentData: documentData,
                    documentBinary: documentBinary,
                },
            },
        };
        return this.http.post<DocumentumStoreResponse>(`${this.url}/store`, documentum);
    }

    public listAll(request: any, page: number = 1, size: number = 100): Observable<ListAllDocumentum> {
        const headers = new HttpHeaders({
            loginName: "dmadmin",
        });
        return this.http.post<ListAllDocumentum>(
            `${this.url}/list/atlas/expgnrl02?page=${page}&size=${size}`,
            request,
            { headers }
        );
    }

    public delete(objectId: string): Observable<DocumentumDeleteResponse> {
        const request = {
            headerRequest: this.headerRequest,
            businessRequest: {
                deleteDocumentData: {
                    authentication: this.authentication,
                    objectId,
                },
            },
        };
        return this.http.post<DocumentumDeleteResponse>(`${this.url}/delete`, request);
    }

    public getOneFile(idArchivo: string): Observable<DocumentumGetResponse> {
        const request = {
            headerRequest: this.headerRequest,
            businessRequest: {
                getDocumentData: {
                    authentication: {
                        username: 'dmadmin'
                    },
                    objectId: idArchivo
                },
            },
        };
        return this.http.post<DocumentumGetResponse>(this.url + '/get', request)
    }

    procesarParametroIdentific(identific: string, claves: any[]): DocumentumIdentificModulo {
        return this.metadatosDocumentumService.procesarParametrosGenerico<DocumentumIdentificModulo>(
            identific,
            claves,
            this.separadorParametros
        );
    }

    generarCadenaParametros(...valores: (string | number)[]): string {
        return this.metadatosDocumentumService.generarCadenaParametros(...valores);
    }
}